const CouponService = class CouponService {
  constructor ($http, Configuration) {
    'ngInject'
    this.$http = $http
    this.config = Configuration
  }

  persist (couponCode) {
    console.log('[CouponService] > persist > couponCode', couponCode)
    return this.$http
      .post(`${this.config.apiUrl}/users/persist_coupon`, { coupon_code: couponCode })
      .then(() => {
        console.log('[CouponService] > persist > success')
      })
  }

  fetch () {
    return this.$http
      .get(`${this.config.apiUrl}/users/fetch_coupon`)
      .then(response => {
        const couponCode = response.data.couponCode
        console.log('[CouponService] > fetch > couponCode', couponCode)
        return couponCode
      })
  }
}
export default CouponService
